import React from 'react';
import styled, { css } from 'styled-components';
import {
  FormDropdown,
  FormDropdownOption,
} from '@sparknz/spark-pattern-library';
import { LinkRegion, trackCustomLink } from '@sparknz/tracking';

import { useQuery } from 'shared/hooks';
import { extractFirstValue } from 'shared/utils/query.utils';
import {
  FALLBACK_SORT_VALUE,
  SortOptions,
} from '../../../utils/applyFilters.utils';

const StyledFormDropdown = styled(FormDropdown)`
  ${({ theme: { media } }) => css`
    margin: 0;
    width: 100%;
    height: 48px;

    ${media.up('slim')} {
      width: 240px;
    }
  `}
`;

export interface SortProps {
  className?: string;
}

export default function SortFilter({ className }: SortProps) {
  const { replaceQuery, query } = useQuery();

  const selectedSortValue =
    extractFirstValue(query.sort) ?? FALLBACK_SORT_VALUE;
  const selectedSortOption = SortOptions.find(
    (sortOption) => sortOption.value === selectedSortValue,
  );

  function handleChange(option: FormDropdownOption<string>) {
    trackCustomLink(option.label);
    replaceQuery({
      ...query,
      sort: option.value,
    });
  }

  return (
    <LinkRegion regionId="sort">
      <StyledFormDropdown
        maxMenuHeight="168px"
        className={className}
        options={SortOptions}
        value={selectedSortOption}
        onChange={handleChange}
      />
    </LinkRegion>
  );
}
